var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1826_4120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 37.584H44.5",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 44.25H19.5",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 30.916H44.5",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 24.25H34.5",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 27.5833H28.6667C28.9963 27.5833 29.3185 27.6811 29.5926 27.8642C29.8667 28.0474 30.0803 28.3077 30.2065 28.6122C30.3326 28.9167 30.3656 29.2518 30.3013 29.5752C30.237 29.8985 30.0783 30.1954 29.8452 30.4285C29.6121 30.6616 29.3151 30.8203 28.9918 30.8846C28.6685 30.949 28.3334 30.9159 28.0289 30.7898C27.7243 30.6637 27.464 30.45 27.2809 30.176C27.0977 29.9019 27 29.5796 27 29.25V25.0833C27 24.1993 27.3512 23.3514 27.9763 22.7263C28.6014 22.1012 29.4493 21.75 30.3333 21.75",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 27.5833H21.1667C21.4963 27.5833 21.8185 27.6811 22.0926 27.8642C22.3667 28.0474 22.5803 28.3077 22.7065 28.6122C22.8326 28.9167 22.8656 29.2518 22.8013 29.5752C22.737 29.8985 22.5783 30.1954 22.3452 30.4285C22.1121 30.6616 21.8151 30.8203 21.4918 30.8846C21.1685 30.949 20.8334 30.9159 20.5289 30.7898C20.2243 30.6637 19.964 30.45 19.7809 30.176C19.5977 29.9019 19.5 29.5796 19.5 29.25V25.0833C19.5 24.1993 19.8512 23.3514 20.4763 22.7263C21.1014 22.1012 21.9493 21.75 22.8333 21.75",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1826_4120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(12 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.53c10a081654be540a2a2e3836136cf9.svg";
export { ForwardRef as ReactComponent };